// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textref {\r\n  display: inline-block;\r\n  margin-top: 2px;\r\n}\r\n\r\n.numberref {\r\n  display: inline-block;\r\n  margin-top: 2px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.selectref {\r\n  margin-right: 6px;\r\n}\r\n\r\n.dateref {\r\n  background-color: white;\r\n  display: inline-block;\r\n  position: relative;\r\n  vertical-align: middle;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
